import { Fab, makeStyles, useTheme } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import moment from 'moment'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  TaskCommentModel,
  TaskCommentWithDateMomentModel
} from '../../../../api/Argentia/endpoints/tasks/model/tasks'
import { CardActionProps } from '../../../../components/shared/cardActions/cardActions'
import { StandardCard } from '../../../../components/shared/standardCard/standardCard'
import { formatDateOnlyStringWithTime } from '../../../../helpers/formatDateOnly'
import { styles } from './commenListCard.styles'
import { CommentListItem } from './components/commentListItem'
import { CommentModal } from './components/commentModal'

interface CommentListCardProps {
  imgPath: string
  comments: TaskCommentModel[] | undefined
  onSaveComment: (textComment: string) => void
  isLoading?: boolean
  footerActions?: CardActionProps[]
}

export const CommmentListCard: React.FC<CommentListCardProps> = ({
  isLoading,
  comments,
  imgPath,
  onSaveComment
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'tasks', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [open, setOpen] = useState<boolean>(false)

  const noData = comments && comments.length === 0
  const sortedComments: TaskCommentWithDateMomentModel[] =
    comments
      ?.map(comment => ({
        ...comment,
        date: comment.date ? moment(comment.date) : undefined
      }))
      .sort((a, b) => {
        if (a.date?.isAfter(b.date)) return -1
        if (a.date?.isBefore(b.date)) return 1
        return 0
      }) ?? []

  // #region Handlers Starts
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <>
      <StandardCard
        title={t('tasks:components.commentListCard.title')}
        emptyCaption={t('tasks:components.commentListCard.emptyCaption')}
        showEmptyContent={noData}
        emptyButtonCallback={handleOpen}
        emptyButtonCaption={t('tasks:components.commentListCard.mainAction.add')}
        isLoading={isLoading}
      >
        <Fab variant="extended" className={classes.fabExtended} size="medium" onClick={handleOpen}>
          <Add color="primary" className={classes.fabIcon} />
          {t('tasks:components.commentListCard.mainAction.add')}
        </Fab>
        {sortedComments.map(comment => (
          <CommentListItem
            imgPath={imgPath}
            date={formatDateOnlyStringWithTime(comment.date) ?? ''}
            description={comment.comment}
            user={comment.user}
          />
        ))}
      </StandardCard>
      <CommentModal isOpen={open} onCloseModal={handleClose} onSaveComment={onSaveComment} />
    </>
  )
}
